import {Injectable} from "@angular/core";
import {MissingTranslationHandler} from "@ngx-translate/core";


/**
 * returns the key of the missing translation wrapped in "[[" and "]]"
 */
@Injectable({providedIn: 'root'})
export class CustomMissingTranslationHandler implements MissingTranslationHandler {

    //translate pipe
    handle(params: { key: string, translateService: any }) {
        console.warn(`Missing translation for key: ${params.key}`);
        return `[[${params.key}]]`;
    }

}